import {
	selectLoadedTable,
	useOrderInfo,
} from 'entities/orders';
import closeWhiteIcon from 'assets/icons/close-icon-white.svg';
import closeIcon from 'assets/icons/close-icon.svg';
import {
	GuestsPanel,
} from 'entities/toolbar/guests';
import { useCallback, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { GuestsList, GuestsTitle, RightIcon } from './styles';
import { selectOrdersByDate, selectOrdersByTable, selectOrdersDelayedNext, selectOrdersLoader, selectOrdersSearchNext, selectOrdersWaitingNext } from 'entities/orders/model/selectors';
import { Preloader } from 'shared/ui/spinner';
import { getOrdersByDate, getOrdersNext } from 'entities/orders/model/ordersThunk';
import { GuestsWaitingNext } from './tabs/GuestsWaitingNext';
import { GuestsDelayedNext } from './tabs/GuestsDelayedNext';
import { Flex } from 'shared/ui/flex';
import { Typography } from 'shared/ui/typography';
import { IconButton } from 'shared/ui/buttons/iconButtons/iconButton';
import { clearLoadedTable, updateOrdersSearchNext } from 'entities/orders/model/ordersSlice';
import { GuestsCard } from 'entities/toolbar/guests/ui/components/GuestCard';
import { selectSelectedTimeslot, useSelectedTimeslot, useTimeslotZone } from 'entities/toolbar/timeslots';
import { getResourcesState } from 'entities/hallmap';
import { useGetSlotsByDate } from 'features/hallmapToolbar/datePicker/lib/useGetSlotsByDate';
import { isToday } from 'date-fns';
import { GuestsDate } from './tabs/GuestsDate';
import { formatWithLocale } from 'shared/lib/datepicker';
import { useCurrentSlotTime } from 'features/hallmapToolbar/currentTimeSwitch';
import { borderRadius } from 'entities/toolbar/guests/ui/types/components';

export const Guests = () => {
	const loadedTable = useAppSelector(selectLoadedTable);
	const isLoading = useAppSelector(selectOrdersLoader);
	const ordersByTable = useAppSelector(selectOrdersByTable);
	const dispatch = useAppDispatch();
	const { toggleOpen, setSelectedId, isOpen, close } = useOrderInfo();
	const { getSlotsByDate } = useGetSlotsByDate();
	const { formatISODateBySlotZone } = useTimeslotZone();
	const { getCurrentTime } = useCurrentSlotTime();
	const delayedNext = useAppSelector(selectOrdersDelayedNext);
	const waitingNext = useAppSelector(selectOrdersWaitingNext);
	const ordersSearch = useAppSelector(selectOrdersSearchNext);
	const ordersByDate = useAppSelector(selectOrdersByDate);
	const selectedTimeslot = useAppSelector(selectSelectedTimeslot);
	const { time } = useSelectedTimeslot(selectedTimeslot);
	const ordersInterval = useRef<any>();
	const slotsInterval = useRef<any>();
	const stateInterval = useRef<any>();
	const panelRef = useRef<HTMLDivElement>();

	const delayedNextFilteredOrders = delayedNext.filter(order => {
		if (ordersSearch?.trim()) {
			if (order?.person?.name?.toLowerCase().includes(ordersSearch?.toLowerCase()) || order?.person?.phone?.replace(/^\d/, '').toLowerCase().includes(ordersSearch?.toLowerCase())) {
				return true;
			}

			return false;
		}


		return true;
	})

	const tableFilteredOrders = ordersByTable.filter(order => {
		if (ordersSearch?.trim()) {
			if (order?.person?.name?.toLowerCase().includes(ordersSearch?.toLowerCase()) || order?.person?.phone?.replace(/^\d/, '').toLowerCase().includes(ordersSearch?.toLowerCase())) {
				return true;
			}

			return false;
		}


		return true;
	})

	const waitingNextFilteredOrders = waitingNext?.map(timeGroup => {
		if (ordersSearch?.trim()) {
			return {
				...timeGroup,
				ordersList: timeGroup.ordersList.filter(order => {
					if (order?.person?.name?.toLowerCase().includes(ordersSearch?.toLowerCase()) || order?.person?.phone?.replace(/^\d/, '').toLowerCase().includes(ordersSearch?.toLowerCase())) {
						return true;
					}

					return false;
				})
			};
		}


		return timeGroup;
	})

	const dateFilteredOrders = ordersByDate?.map(timeGroup => {
		if (ordersSearch?.trim()) {
			return {
				...timeGroup,
				ordersList: timeGroup.ordersList.filter(order => {
					if (order?.person?.name?.toLowerCase().includes(ordersSearch?.toLowerCase()) || order?.person?.phone?.replace(/^\d/, '').toLowerCase().includes(ordersSearch?.toLowerCase())) {
						return true;
					}

					return false;
				})
			};
		}


		return timeGroup;
	})

	const isEmptyDelayedNextOrders = !delayedNextFilteredOrders.length;
	const isEmptyWaitingNextOrders = !waitingNextFilteredOrders?.map(timeGroup => timeGroup.ordersList)?.flat()?.length;

	const isEmptyFilteredOrdersByDate = !dateFilteredOrders?.map(timeGroup => timeGroup.ordersList)?.flat()?.length;
	const isEmptyOrdersByDate = !ordersByDate?.length;

	const isEmptyFilteredOrdersByTable = !tableFilteredOrders.length;

	const isEmptyOrders = !waitingNext?.length && !delayedNext?.length;
	const isEmptySearchOrders = ordersSearch.trim() && isEmptyDelayedNextOrders && isEmptyWaitingNextOrders;
	const isSearchOrdersExists = ordersSearch.trim() && (!isEmptyDelayedNextOrders || !isEmptyWaitingNextOrders);
	const isSearchOrdersByDateExists = ordersSearch.trim() && !isEmptyFilteredOrdersByDate;
	const isSearchOrdersByTableExists = ordersSearch.trim() && !isEmptyFilteredOrdersByTable;

	const onClearSearch = () => {
		dispatch(updateOrdersSearchNext(''));
	}

	const onClearSelectedTable = () => {
		dispatch(clearLoadedTable());
		loadOrdersNext();
	}

	const select = (selectedId: number) => {
		toggleOpen();
		setSelectedId(selectedId);
	};

	const loadOrdersNext = useCallback(() => {
		dispatch(getOrdersNext({}));
	}, [dispatch])

	const loadState = useCallback(() => {
		if (!selectedTimeslot) {
			return;
		}

		dispatch(
			getResourcesState({ dt_requested: selectedTimeslot }),
		);
	}, [selectedTimeslot, dispatch])

	const loadOrdersByDate = useCallback((date: Date) => {
		const dateStart = new Date(date);
		dateStart.setHours(0, 0, 0, 0);
		const dateEnd = new Date(date);
		dateEnd.setHours(23, 59, 59, 59);

		dispatch(getOrdersByDate({
			dt_start__gte: formatISODateBySlotZone(dateStart),
			dt_start__lte: formatISODateBySlotZone(dateEnd),
			status: 'appointed'
		}))
	}, [dispatch, formatISODateBySlotZone])

	const loadSlots = useCallback(() => {
		getSlotsByDate(new Date(selectedTimeslot));
	}, [getSlotsByDate, selectedTimeslot])

	useEffect(() => {
		close();
		if (loadedTable) {
			clearInterval(ordersInterval.current);
			ordersInterval.current = null;
		}
	}, [loadedTable, close]);

	useEffect(() => {
		if (isOpen) {
			clearInterval(ordersInterval.current);
			ordersInterval.current = null;
		}
	}, [isOpen])

	useEffect(() => {
		if (!loadedTable && !isOpen) {
			if (isToday(selectedTimeslot)) {
				loadOrdersNext();
				clearInterval(ordersInterval.current);
				ordersInterval.current = setInterval(loadOrdersNext, 5_000);
			} else {
				if (!selectedTimeslot) {
					return;
				}

				loadOrdersByDate(new Date(selectedTimeslot));
			}
		}
		// eslint-disable-next-line
	}, [loadedTable, isOpen])

	useEffect(() => {
		if (ordersSearch.trim()) {
			close();
		}
	}, [ordersSearch, close, dispatch])

	useEffect(() => {
		if (!isOpen) {
			if (isToday(selectedTimeslot)) {
				clearInterval(stateInterval.current);
				clearInterval(slotsInterval.current);
				loadState();
				loadSlots();
				stateInterval.current = setInterval(loadState, 5_000);
				slotsInterval.current = setInterval(loadSlots, 5_000);
			}
			scrollToTimeGroup(`group-${time}`)
		}
		// eslint-disable-next-line
	}, [isOpen])

	function scrollToTimeGroup(elementId: string) {
		const element = document.getElementById(elementId);
		if (!element) {
			return;
		}

		const offset = 220;
		const elementPosition = element.offsetTop;

		panelRef.current?.scrollTo({
			top: elementPosition - offset,
			behavior: "smooth"
		});
	}

	useEffect(() => {
		if (!selectedTimeslot) {
			return;
		}

		clearInterval(slotsInterval.current);
		slotsInterval.current = null;
		clearInterval(stateInterval.current);
		stateInterval.current = null;
		clearInterval(ordersInterval.current);
		ordersInterval.current = null;

		loadState();
		loadSlots();
		stateInterval.current = setInterval(loadState, 5_000);
		slotsInterval.current = setInterval(loadSlots, 5_000);

		if (isToday(selectedTimeslot)) {
			loadOrdersNext();
			ordersInterval.current = setInterval(loadOrdersNext, 5_000);
			if (getCurrentTime() !== time) {
				scrollToTimeGroup(`group-${time}`);
			}
		} else {
			loadOrdersByDate(new Date(selectedTimeslot));
			setTimeout(() => scrollToTimeGroup(`group-${time}`), 500);
		}

		// eslint-disable-next-line
	}, [selectedTimeslot])

	useEffect(() => {
		return () => {
			clearInterval(ordersInterval.current);
			ordersInterval.current = null;
			clearInterval(slotsInterval.current);
			slotsInterval.current = null;
			clearInterval(stateInterval.current);
			stateInterval.current = null;
		};
	}, [])

	if (!isToday(selectedTimeslot) && !isOpen && !loadedTable) {
		return (
			<GuestsPanel>
				{isEmptyOrdersByDate && (
					<Flex $justify="center" $height="100%" $alignItems="center">
						<Typography mode={'large'}>Нет данных</Typography>
					</Flex>
				)}
				{!isEmptyOrdersByDate && (
					<GuestsList ref={panelRef} id="guests-list">
						{isEmptyFilteredOrdersByDate && (
							<Flex $justify="center" $height="100%" $alignItems="center" $padding="0 40px 0 0">
								<Typography mode="small" whiteSpace="break-spaces" wordBreak="break-all">НЕТ БРОНИРОВАНИЙ ПО ЗАПРОСУ: {ordersSearch}</Typography>
								<RightIcon><IconButton onClick={onClearSearch} iconSrc={closeIcon} styles={{ iconHeight: '10px' }} /></RightIcon>
							</Flex>
						)}
						{isSearchOrdersByDateExists && (
							<GuestsTitle $variant="main" fontSize={12}>НАЙДЕНО ПО ЗАПРОСУ: {ordersSearch} <RightIcon><IconButton onClick={onClearSearch} iconSrc={closeWhiteIcon} styles={{ iconHeight: '10px' }} /></RightIcon></GuestsTitle>
						)}
						<GuestsDate select={select} orders={dateFilteredOrders} isEmpty={isEmptyFilteredOrdersByDate} />
					</GuestsList>
				)}
			</GuestsPanel>
		)
	}

	return (
		<>
			{!isOpen && (
				<>
					{loadedTable ? (
						<GuestsPanel>
							<GuestsList>
								{!isSearchOrdersByTableExists && <GuestsTitle $variant="main" fontSize={12}>СТОЛ {loadedTable} {!isToday(selectedTimeslot) ? `НА ${formatWithLocale(new Date(selectedTimeslot), 'dd.MM.yyyy (E)')}` : null} {tableFilteredOrders.length}/{tableFilteredOrders.reduce((orderPersons, order) => orderPersons + order.participants_count, 0)} <RightIcon><IconButton onClick={onClearSelectedTable} iconSrc={closeWhiteIcon} styles={{ iconHeight: '10px' }} /></RightIcon></GuestsTitle>}
								{isLoading && (
									<Flex $justify="center" $height="100%" $alignItems="center">
										<Preloader />
									</Flex>
								)}
								{Boolean(ordersByTable.length) && (
									<>
										{isSearchOrdersByTableExists && (
											<GuestsTitle $variant="main" fontSize={12}>НАЙДЕНО ПО ЗАПРОСУ: {ordersSearch} <RightIcon><IconButton onClick={onClearSearch} iconSrc={closeWhiteIcon} styles={{ iconHeight: '10px' }} /></RightIcon></GuestsTitle>
										)}
										{isEmptyFilteredOrdersByTable && (
											<Flex $justify="center" $height="100%" $alignItems="center" $padding="0 40px 0 0">
												<Typography mode="small" whiteSpace="break-spaces" wordBreak="break-all">НЕТ БРОНИРОВАНИЙ ПО ЗАПРОСУ: {ordersSearch}</Typography>
												<RightIcon><IconButton onClick={onClearSearch} iconSrc={closeIcon} styles={{ iconHeight: '10px' }} /></RightIcon>
											</Flex>
										)}
										{tableFilteredOrders.map((order, index) => {
                      const borderRadius = {} as borderRadius;
                      if (index === 0) {
                        borderRadius.topLeft = 12;
                        borderRadius.topRight = 12;
                      }
                      if (index === tableFilteredOrders.length - 1) {
                        borderRadius.bottomLeft = 12;
                        borderRadius.bottomRight = 12;
                      }
                      return (
                        <GuestsCard key={order.id} select={select} order={order} borderRadius={borderRadius} />
                      )
                    })}
									</>
								)}
								{!ordersByTable.length && (
									<Flex $justify="center" $height="100%" $alignItems="center">
										<Typography mode={'large'}>Нет данных</Typography>
									</Flex>
								)}
							</GuestsList>
						</GuestsPanel>
					) : (
						<GuestsPanel>
							{isEmptyOrders && (
								<Flex $justify="center" $height="100%" $alignItems="center">
									<Typography mode={'large'}>Нет данных</Typography>
								</Flex>
							)}
							{!isEmptyOrders && (
								<GuestsList ref={panelRef} id="guests-list">
									{isSearchOrdersExists && (
										<GuestsTitle $variant="main" fontSize={12}>НАЙДЕНО ПО ЗАПРОСУ: {ordersSearch} <RightIcon><IconButton onClick={onClearSearch} iconSrc={closeWhiteIcon} styles={{ iconHeight: '10px' }} /></RightIcon></GuestsTitle>
									)}
									{isEmptySearchOrders && (
										<Flex $justify="center" $height="100%" $alignItems="center" $padding="0 40px 0 0">
											<Typography mode="small" whiteSpace="break-spaces" wordBreak="break-all">НЕТ БРОНИРОВАНИЙ ПО ЗАПРОСУ: {ordersSearch}</Typography>
											<RightIcon><IconButton onClick={onClearSearch} iconSrc={closeIcon} styles={{ iconHeight: '10px' }} /></RightIcon>
										</Flex>
									)}
									<GuestsDelayedNext select={select} orders={delayedNextFilteredOrders} isEmpty={isEmptyDelayedNextOrders} />
									<GuestsWaitingNext select={select} orders={waitingNextFilteredOrders} isEmpty={isEmptyWaitingNextOrders} />
								</GuestsList>
							)}
						</GuestsPanel>
					)}
				</>
			)}
		</>
	);
};
